import React, { useMemo } from "react";
import isEmpty from "lodash/isEmpty";
import Loading from "../../../../shared/loading/loading";
import AppEmpty from "../../../../shared/appEmpty/appEmpty";
import PostPlanChart from "./postPlanChart";

const PostPlanGraph = ({ data, loading, handleOpenConfig }) => {
  const chart = useMemo(() => {
    return <PostPlanChart data={data} handleOpenConfig={handleOpenConfig}/>
  }, [data]);

  if (loading) return <div className="PostPlanGraph center"><Loading /></div>
  // no data tree - empty state
  if (!loading && isEmpty(data?.nodes)) {
    return (
      <div className="PostPlanGraph center">
        <AppEmpty customStyle="code" text="The current Terraform plan does not contain any infrastructure changes" />
      </div>
    );
  }

  return <div className="PostPlanGraph">
          <div className="PostPlanChart">{chart}</div>
        </div>;
};

export default PostPlanGraph;
